import '../scss/section-bottom-quick-links.scss';

export class QuickLink extends HTMLElement {
  constructor() {
    super();

    this.mobileMedia = window.matchMedia('(max-width: 749px)');
    this.toggleEvent = this.toggle.bind(this); // Stocke la fonction pour pouvoir la retirer si besoin
    this.updateMode(); // Applique le bon comportement au chargement
    // Écoute les changements de taille d'écran
    this.mobileMedia.addEventListener('change', () => this.updateMode());
  }

  updateMode() {
    if (this.mobileMedia.matches) {
      // Mobile : ajouter l'event si pas encore attaché
      if (!this.hasClickListener) {
        this.classList.add('hide');
        this.addEventListener('click', this.toggleEvent);
        this.hasClickListener = true;
      }
    } else {
      // Desktop : supprimer l'event et afficher le contenu
      this.classList.remove('hide');

      this.removeEventListener('click', this.toggleEvent);
      this.hasClickListener = false;
      this.show();
    }
  }

  toggle() {
    if (this.classList.contains('hide')) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.classList.remove('hide');
  }

  hide() {
    this.classList.add('hide');
  }
}

customElements.define('quick-link', QuickLink);
